var map = {
	"./add.svg": 14780,
	"./book-focus.svg": 59063,
	"./book.svg": 96004,
	"./bookmark-focus.svg": 36566,
	"./bookmark.svg": 28619,
	"./home-focus.svg": 30339,
	"./home.svg": 32520,
	"./user-focus.svg": 8444,
	"./user.svg": 51816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36075;